





















import Vue from 'vue';
import { mapMutations } from 'vuex';
import { SET_SIDEBAR_OPEN } from './../../store/types';
export default Vue.extend({
  name: 'SidebarToggle',

  methods: {
    ...mapMutations({
      setSidebarOpen: SET_SIDEBAR_OPEN
    })
  }
});
